/* eslint import/no-cycle: "off" */
import React from 'react';
import { observer } from 'mobx-react';
import { Helmet } from 'react-helmet';
import { pageTitle } from '../static';
import Header from './Header/Header';
import Headroom from 'react-headroom';
import { ApiIncludedService, ApiPackageModel } from '@ibe/api';
import { BreadcrumbProps } from '../Components/MMB/NavigationBreadcrumb/NavigationBreadcrumb';
import Footer from './Footer/Footer';

export interface LocationSnapshot {
  pathname: string;
  search: string;
}
interface Props {
  children: React.ReactNode;
  title?: string;
  stickyHeader?: boolean;
  breadcrumbProps?: BreadcrumbProps;
  onGoToCheckout?: () => Promise<void>;
  editBookingItemExtension?: (itemIDs: Array<string>) => void;
  className?: string;
  packageIncludedServices?: Array<ApiIncludedService>;
  packageModel?: ApiPackageModel;
  hideFooter?: boolean;
}

const BlankPageLayout = observer(function BlankPageLayout(props: Props) {
  const {
    children,
    stickyHeader,
    breadcrumbProps,
    onGoToCheckout,
    editBookingItemExtension,
    className,
    packageIncludedServices,
    packageModel,
    hideFooter
  } = props;

  const title = props.title ? `${props.title} | ${pageTitle}` : `${pageTitle}`;

  return (
    <div className={`blank-page-layout ${className}`}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
      </Helmet>
      <div className={'mb-1 mb-md-3 header'}>
        <Headroom disableInlineStyles pinStart={0} disable={!stickyHeader} className="mb-3">
          <div className="iso__header-container">
            <Header
              breadcrumbProps={breadcrumbProps}
              onGoToCheckout={onGoToCheckout}
              editBookingItemExtension={editBookingItemExtension}
              packageIncludedServices={packageIncludedServices}
              packageModel={packageModel}
            />
          </div>
        </Headroom>
      </div>
      <h1 className={'page-title'} role={'main'}>
        {title}
      </h1>
      <div className={`backgroundContainer container-fluid ${className}__wrapper`}>{children}</div>
      {hideFooter ? null : <Footer />}
    </div>
  );
});

export default BlankPageLayout;
